import * as React from "react";
import { Card, Stack, Typography } from "@mui/material";
import { SimpleBreadcrumbs } from "../../components/navigation/simpleBreadcrumbs";
import StandardLayout from "../../layouts/standard";
import { PayrollTabs } from "./payrollTabPanel";


export const Payroll: React.FC = () => {

    const breadcrumbs = (
        <SimpleBreadcrumbs>
            <Typography variant="h6" color="text.primary">
                {"Payroll"}
            </Typography>
        </SimpleBreadcrumbs>
    );

    return (
        <StandardLayout breadcrumbs={breadcrumbs}>
            <Stack height={1} width={1}>
                <Card sx={{ height: 1, width: 1, display: "flex", flexDirection: "column" }}>
                    <PayrollTabs defaultTab={"8"} />
                </Card>
            </Stack>
        </StandardLayout>
    );
};

export default Payroll;
